// Author Lin
// Date 2021-11-03 09:23:16

class MintalMesPrdSmeltingSlagIron {
        constructor({
                id = null,
                locationId = '',
                locationName = '',
                shiftId = '',
                shiftName = '',
                productionDate = '',
                furnaceId = '',
                furnaceName = '',
                startTime = '',
                dischargeTime = '',
                furnaceBatch = '',
                drillNumber = '',
                depth = '',
                drillTubeNumber = '',
                otherTubeNumber = '',
                mudName = '',
                mudNumber = '',
                firstPackageNumber = '',
                secondPackageNumber = '',
                firstPackageWeight = '',
                secondPackageWeight = '',
                firstWeightAfterSlag = '',
                secondWeightAfterSlag = '',
                firstWeightAfterCasting = '',
                secondWeightAfterCasting = '',
                totalIronWeight = '',
                totalCastingWeight = '',
                residualWeight = '',
                energyConsumption = '',
                tappingPowerConsumption = '',
                castingPowerConsumption = '',
                chromiumContent = '',
                siliconContent = '',
                carbonContent = '',
                sulfurContent = '',
                phosphorusContent = '',
                totalSlag = '',
                chromiumOxide = '',
                calciumOxide = '',
                magnesiumOxide = '',
                alumina = '',
                siliconDioxide = '',
                ironInSlag = '',
                alkalinity = '',
                recorderId = '',
                recorder = '',
                reviewerId = '',
                reviewer = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.locationId = locationId;
            this.locationName = locationName;
            this.shiftId = shiftId;
            this.shiftName = shiftName;
            this.productionDate = productionDate;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.startTime = startTime;
            this.dischargeTime = dischargeTime;
            this.furnaceBatch = furnaceBatch;
            this.drillNumber = drillNumber;
            this.depth = depth;
            this.drillTubeNumber = drillTubeNumber;
            this.otherTubeNumber = otherTubeNumber;
            this.mudName = mudName;
            this.mudNumber = mudNumber;
            this.firstPackageNumber = firstPackageNumber;
            this.secondPackageNumber = secondPackageNumber;
            this.firstPackageWeight = firstPackageWeight;
            this.secondPackageWeight = secondPackageWeight;
            this.firstWeightAfterSlag = firstWeightAfterSlag;
            this.secondWeightAfterSlag = secondWeightAfterSlag;
            this.firstWeightAfterCasting = firstWeightAfterCasting;
            this.secondWeightAfterCasting = secondWeightAfterCasting;
            this.totalIronWeight = totalIronWeight;
            this.totalCastingWeight = totalCastingWeight;
            this.residualWeight = residualWeight;
            this.energyConsumption = energyConsumption;
            this.tappingPowerConsumption = tappingPowerConsumption;
            this.castingPowerConsumption = castingPowerConsumption;
            this.chromiumContent = chromiumContent;
            this.siliconContent = siliconContent;
            this.carbonContent = carbonContent;
            this.sulfurContent = sulfurContent;
            this.phosphorusContent = phosphorusContent;
            this.totalSlag = totalSlag;
            this.chromiumOxide = chromiumOxide;
            this.calciumOxide = calciumOxide;
            this.magnesiumOxide = magnesiumOxide;
            this.alumina = alumina;
            this.siliconDioxide = siliconDioxide;
            this.ironInSlag = ironInSlag;
            this.alkalinity = alkalinity;
            this.recorderId = recorderId;
            this.recorder = recorder;
            this.reviewerId = reviewerId;
            this.reviewer = reviewer;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingSlagIron();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.shiftName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'productionDate',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.productionDate',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'startTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.startTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dischargeTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.dischargeTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceBatch',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.furnaceBatch',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'drillNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.drillNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'depth',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.depth',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'drillTubeNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.drillTubeNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'otherTubeNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.otherTubeNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mudName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.mudName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mudNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.mudNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'firstPackageNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.firstPackageNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondPackageNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.secondPackageNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'firstPackageWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.firstPackageWeight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondPackageWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.secondPackageWeight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'firstWeightAfterSlag',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.firstWeightAfterSlag',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondWeightAfterSlag',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.secondWeightAfterSlag',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'firstWeightAfterCasting',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.firstWeightAfterCasting',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondWeightAfterCasting',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.secondWeightAfterCasting',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'totalIronWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.totalIronWeight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'totalCastingWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.totalCastingWeight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'residualWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.residualWeight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'energyConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.energyConsumption',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'tappingPowerConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.tappingPowerConsumption',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'castingPowerConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.castingPowerConsumption',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'chromiumContent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.chromiumContent',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'siliconContent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.siliconContent',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'carbonContent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.carbonContent',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'sulfurContent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.sulfurContent',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'phosphorusContent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.phosphorusContent',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'totalSlag',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.totalSlag',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'chromiumOxide',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.chromiumOxide',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'calciumOxide',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.calciumOxide',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'magnesiumOxide',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.magnesiumOxide',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'alumina',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.alumina',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'siliconDioxide',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.siliconDioxide',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'ironInSlag',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.ironInSlag',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'alkalinity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.alkalinity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.recorder',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewer',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.reviewer',
                sortable: true,
                isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            locationIdFilter : '',
            locationNameFilter : '',
            shiftIdFilter : '',
            shiftNameFilter : '',
            productionDateRteFilter : '',
            productionDateLteFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            startTimeRteFilter : '',
            startTimeLteFilter : '',
            dischargeTimeFilter : '',
            furnaceBatchFilter : '',
            drillNumberFilter : '',
            depthFilter : '',
            drillTubeNumberFilter : '',
            otherTubeNumberFilter : '',
            mudNameFilter : '',
            mudNumberFilter : '',
            firstPackageNumberFilter : '',
            secondPackageNumberFilter : '',
            firstPackageWeightFilter : '',
            secondPackageWeightFilter : '',
            firstWeightAfterSlagFilter : '',
            secondWeightAfterSlagFilter : '',
            firstWeightAfterCastingFilter : '',
            secondWeightAfterCastingFilter : '',
            totalIronWeightFilter : '',
            totalCastingWeightFilter : '',
            residualWeightFilter : '',
            energyConsumptionFilter : '',
            tappingPowerConsumptionFilter : '',
            castingPowerConsumptionFilter : '',
            chromiumContentFilter : '',
            siliconContentFilter : '',
            carbonContentFilter : '',
            sulfurContentFilter : '',
            phosphorusContentFilter : '',
            totalSlagFilter : '',
            chromiumOxideFilter : '',
            calciumOxideFilter : '',
            magnesiumOxideFilter : '',
            aluminaFilter : '',
            siliconDioxideFilter : '',
            ironInSlagFilter : '',
            alkalinityFilter : '',
            recorderIdFilter : '',
            recorderFilter : '',
            reviewerIdFilter : '',
            reviewerFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'shiftNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.shiftName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'productionDateRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.productionDateRte',
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'productionDateLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.productionDateLte',
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'startTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.startTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'startTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.startTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'furnaceBatchFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.furnaceBatch',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'drillNumberFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.drillNumber',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'mudNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.mudName',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'recorderFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.recorder',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                // {
                // key: 'reviewerFilter',
                // label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.filter.reviewer',
                // disabled: false,
                // form: {
                // type: 'entityModalSelect'
                //     ,entity: 'emAclUser'
                //     ,correspondingField: 'name'
                //     ,fieldsBindingByEntityModalSelected: '{"reviewerId":"id"}'
                //         }
                // }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.shiftName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'productionDate',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.productionDate',
                sortable: true,
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'startTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.startTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datepicker'
                        }
                },
                {
                key: 'dischargeTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.dischargeTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'furnaceBatch',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.furnaceBatch',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'drillNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.drillNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'depth',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.depth',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'drillTubeNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.drillTubeNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'otherTubeNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.otherTubeNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'mudName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.mudName',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'mudNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.mudNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'firstPackageNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.firstPackageNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'secondPackageNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.secondPackageNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'firstPackageWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.firstPackageWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondPackageWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.secondPackageWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'firstWeightAfterSlag',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.firstWeightAfterSlag',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondWeightAfterSlag',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.secondWeightAfterSlag',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'firstWeightAfterCasting',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.firstWeightAfterCasting',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondWeightAfterCasting',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.secondWeightAfterCasting',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'totalIronWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.totalIronWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'totalCastingWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.totalCastingWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'residualWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.residualWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'energyConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.energyConsumption',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'tappingPowerConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.tappingPowerConsumption',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'castingPowerConsumption',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.castingPowerConsumption',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'chromiumContent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.chromiumContent',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'siliconContent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.siliconContent',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'carbonContent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.carbonContent',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'sulfurContent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.sulfurContent',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'phosphorusContent',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.phosphorusContent',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'totalSlag',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.totalSlag',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'chromiumOxide',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.chromiumOxide',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'calciumOxide',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.calciumOxide',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'magnesiumOxide',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.magnesiumOxide',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'alumina',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.alumina',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'siliconDioxide',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.siliconDioxide',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'ironInSlag',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.ironInSlag',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'alkalinity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.alkalinity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.recorder',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                // {
                // key: 'reviewer',
                // label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.reviewer',
                // sortable: true,
                // disabled: false,
                // form: {
                // type: 'entityModalSelect'
                //     ,entity: 'emAclUser'
                //     ,correspondingField: 'name'
                //     ,fieldsBindingByEntityModalSelected: '{"reviewerId":"id"}'
                //         }
                // },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSlagIron.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingSlagIron, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        